<ng-container *ngIf="hasLoaded|async">
  <mat-selection-list class="roles-list" [(ngModel)]="currentUserRoles"
                      (ngModelChange)="handleRoleListChange($event, currentUser.username)">
    <mat-list-option *ngFor="let role of allUserRoles" [value]="role"
                     [selected]="isEnabledRole(role)"
                     [disabled]="isDisabledRole(role)">
      <span [matTooltip]="role" matTooltipPosition="after">{{role|permissionName}}</span>
    </mat-list-option>
  </mat-selection-list>
</ng-container>
